import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, themeMode } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const Handle = styled(Box)`
    background-color: ${({ isDisabled }) => isDisabled ? palette("neutral.400") : palette("primary.500")};
    position: absolute;
    cursor: ${({ isDisabled }) => isDisabled ? "auto" : "pointer"};
    ${({ radius }) => `
        width: ${radius * 2}px;
        height: ${radius * 2}px;
        border-radius: ${radius * 2}px;
        top: ${-radius}px;
        left: ${-radius}px;
    `};
    ${({ isDisabled }) => isDisabled && `pointer-events: none;`};
`;
const Draggable = styled.div`
    transform: ${({ position, radius }) => `translateX(${position - radius / 2}px)`};
    position: absolute;
`;
const Rail = styled(Box)`
    width: 100%;
    height: 2px;
    background-color: ${({ isDisabled }) => isDisabled ? palette("neutral.400") : themeMode({ light: palette("neutral.300"), dark: palette("neutral.600") })};
`;
const ActiveRangeRail = styled(Box)`
    position: absolute;
    width: ${({ range }) => `${range.max - range.min}px`};
    height: 2px;
    background-color: ${({ isDisabled }) => isDisabled ? palette("neutral.400") : palette("primary.500")};
    transform: ${({ range, handleRadius }) => `translateX(${range.min - handleRadius}px)`};
`;
const Slider = styled(Box)`
    display: flex;
    flex-direction: column;
`;

export { ActiveRangeRail, Draggable, Handle, Rail, Slider };
//# sourceMappingURL=styled.es.js.map
